import { blocks, view } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';
import getClosestBlockElement from 'src/js/modules/common/helpers/get-closest-block-element';

const {
  trackers: { trackEvent },
  constants,
} = segment;

const trackStretchCompositeItem = ({ elementId, stretched, breakpointType }) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const block = getClosestBlockElement(liveElement);
  const blockId = blocks.accessors.getBlockIdByElement(block);
  const blockVariationId = blocks.accessors.getVariationIdByElement(block);

  trackEvent(constants.events.COMPOSITE_GROUP_STRETCH_CLICKED, {
    blockId,
    blockVariationId,
    stretched,
    ...(breakpointType && { breakpointType }),
  });
};

export default trackStretchCompositeItem;
